/** Used to group downloaded data together with hash and loading status */
export function DecodeToken(jwtToken: string): JwtToken {
	if (jwtToken == null)
		return new JwtToken();

	const [rawHead, payload, signature] = jwtToken.split(".");

	if (payload == null)
		return new JwtToken();

	const trimmedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
	const jsonPayload = decodeURIComponent(atob(trimmedPayload).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	const jwt = JSON.parse(jsonPayload);

	return jwt;
}

export class JwtToken {
	exp = 0;
	IsAdministrator = '';
	email = '';
	loginID = 0;

	/** Haven't worked out why, but for roles to work in MVC, the array needed to be called Role */
	Role: string[] | string = [];
}